/**
 * Returns a relative timestamp since navigation start for time span measuring.
 * NOTE: This function is only for measuring time, do NOT use in telemetry.
 */
export function getRelativeTimeSinceNavigationStart(): number {
  return window.performance.now();
}

/**
 * Return absolute timestamp since epoch.
 */
export function getAbsoluteTimeSinceEpoch(): number {
  return Math.round(window.performance.now() + window.performance.timeOrigin);
}

export function trySetPerformanceMark(markNames: string | string[]) {
  if (Array.isArray(markNames)) {
    markNames.forEach((markName) => {
      window.performance.mark(markName);
    });
  } else {
    window.performance.mark(markNames);
  }
}
